import React from 'react';

import { closestCenter, DndContext } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import cx from 'classnames';

import AddMinusButton from 'components/shared/AddMinusButton';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';

import { useListBlockItem } from './functions';
import s from './index.module.css';
import ListBlockItem from './Item';
import { IListBlockItemData } from './Item/types';

function ListBlock() {
  const { items, handleDeleteItem, handleChangeItem, handleAddItem, sensors, handleDragEnd, itemsDndIds, readonly } =
    useListBlockItem();

  return (
    <div className={cx(s.wrapper, 'custom-listblock-wrapper')}>
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={itemsDndIds} strategy={verticalListSortingStrategy}>
          {itemsDndIds.map((id) => (
            <ListBlockItem
              key={id}
              id={id}
              data={items[Number(id)]}
              onChange={(data: IListBlockItemData) => handleChangeItem(id, data)}
              onDelete={items?.length > 1 && ((() => handleDeleteItem(id)) as any)}
              readOnly={readonly}
            />
          ))}
          {!readonly && (
            <FormActions isCenter>
              <AddMinusButton onClick={handleAddItem} />
            </FormActions>
          )}
        </SortableContext>
      </DndContext>
    </div>
  );
}

export default ListBlock;
